module.exports = __webpack_public_path__ + "img/video-didaima.7ec12efb.jpg";